export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-teal-50 via-blue-50 to-white"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
      
      <div className="relative max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-block">
              <span className="bg-teal-500 text-white px-4 py-2 rounded-full text-sm font-medium">
                VPN SERVICE
              </span>
            </div>
            
            <h1 className="text-6xl md:text-7xl font-bold text-gray-900 leading-tight">
              Secure Your<br />
              Digital Life<br />
              With Privacy
            </h1>
            
            <p className="text-xl text-gray-600 leading-relaxed max-w-xl">
              Experience ultimate online freedom with military-grade encryption. Browse anonymously, access content worldwide, and protect your digital identity with JURINE VPN.
            </p>
            
            <div className="space-y-4">
              <button
                onClick={scrollToContact}
                className="bg-gray-900 text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-gray-800 transition-all flex items-center gap-3 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-shield-check-line text-xl"></i>
                Start Protection
              </button>
              
              <p className="text-sm text-gray-500 flex items-center gap-2">
                <i className="ri-mail-line"></i>
                information@jurinesarl.com
              </p>
            </div>
          </div>
          
          <div className="relative hidden md:block">
            <div className="relative w-full h-[600px]">
              <img
                src="https://public.readdy.ai/ai/img_res/a9c1d77cc2c6e32b342e1ed07f6ad5cf.jpg"
                alt="VPN Security Illustration"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
